const authMiddleware = store => {
  // Verificação contínua a cada 5 segundos
  setInterval(() => {
    const tokenExpiration = localStorage.getItem("tokenExpiration");

    if (tokenExpiration && new Date().getTime() > tokenExpiration) {
      // Token expirou, então deslogue o usuário
      localStorage.removeItem("isLogin");
      localStorage.removeItem("accessToken");
      localStorage.removeItem("tokenExpiration");

      store.dispatch({
        type: "LOGOUT",
        isLogin: false,
        accessToken: null,
        email: null
      });
    }
  }, 5000); // Verifica a cada 5 segundos

  return next => action => next(action);
};

export default authMiddleware;
